import {
    SET_searchInputValue,
    SET_title,
    SET_tabbarIndex,
    SET_userSexMan,
    SET_userSexWomen,
    SET_userSexDefault,
    SET_userAddress,
    UPDATE_loadingStatus,
    SET_avatar,
    SET_name,
    SET_nickName,
    SET_mobile,
    SET_userLoginIn,
    SET_userLoginOut,
    SET_type,
    SET_orgLogo,
    SET_baseurl,
    SET_userBindingIn,
    SET_userBindingOut,
    SET_orgName
} from './mutations-type'

const mutations = {
    [SET_searchInputValue]: function(state, searchValue) {
        state.searchInputValue = searchValue;
    },
    [SET_title]: function(state, title) {
        state.title = title;
    },
    [SET_tabbarIndex]: function(state, index) {
        state.tabbarIndex = index;
    },
    [SET_userSexMan]: function(state) {
        state.userSex = '男';
    },
    [SET_userSexWomen]: function(state) {
        state.userSex = '女';
    },
    [SET_userSexDefault]: function(state) {
        state.userSex = '请选择性别';
    },
    [SET_userAddress]: function(state, address) {
        state.userAddress = address;
    },
    [UPDATE_loadingStatus]: function(state, payload) {
        state.isLoading = payload.isLoading
    },
    [SET_avatar]: function(state, avatar) {
        state.avatar = avatar;
    },
    [SET_name]: function(state, name) {
        state.name = name;
    },
    [SET_nickName]: function(state, nickname) {
        state.nickname = nickname;
    },
    [SET_mobile]: function(state, mobile) {
        state.mobile = mobile;
    },
    [SET_userLoginIn]: function(state) {
        state.userLogin = true;
    },
    [SET_userLoginOut]: function(state) {
        state.userLogin = false;
    },
    [SET_userBindingIn]: function(state) {
        state.userBinding = true;
    },
    [SET_userBindingOut]: function(state) {
        state.userBinding = false;
    },
    [SET_type]: function(state, type) {
        state.type = type;
    },
    [SET_orgLogo]: function(state, orgLogoUrl) {
        state.orgLogo = orgLogoUrl;
    },
    [SET_baseurl]: function(state, baseurl) {
        state.baseurl = baseurl;
    },
    [SET_orgName]: function(state, orgName) {
        state.orgName = orgName;
    }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js